import * as Store from '../store/index.js';
import { escapeHtml, escapeAttr } from '../../../engine/core/validation.js';
import { t } from '../../../shared/i18n/index.js';

// Session-only UI state, shared by the panel, full Notes view and mobile.
export const TASK_FILTER_EVENT = 'orbital:note-task-filter';
let filter = null;
Store.subscribe((state, previous) => {
  if (state.currentDocId !== previous.currentDocId) filter = null;
});

export function createTaskFilter(nodeId, callbacks) {
  const node = callbacks.find?.(nodeId);
  const scope = Store.get('currentDocId');
  if (!node || !scope) return null;
  const location = callbacks.getNodeLocation?.(nodeId) || { nodeId };
  return { scope, docId: location.docId || scope, nodeId: location.nodeId,
    displayId: nodeId, title: node.name || t('views.taskFilter.untitled'), includeTitle: false };
}

export function getTaskFilter(callbacks) {
  if (filter?.scope !== Store.get('currentDocId')) return null;
  const node = callbacks?.find?.(filter.displayId);
  const location = node && callbacks.getNodeLocation?.(node.id);
  if (node && location?.nodeId === filter.nodeId &&
      (location.docId || filter.scope) === filter.docId) filter.title = node.name || t('views.taskFilter.untitled');
  return filter;
}

export function setTaskFilter(next, resetQuery = false) {
  filter = next;
  document.dispatchEvent(new CustomEvent(TASK_FILTER_EVENT, { detail: { resetQuery } }));
}

export function taskFilterMarkup(task, count) {
  if (!task) return '';
  return `<div class="note-task-filter">
    <button type="button" class="note-task-chip" data-task-filter-clear title="${t('views.taskFilter.showAll')}" aria-label="${t('views.taskFilter.clear', { title: escapeAttr(task.title) })}">
      <span>${t('views.taskFilter.task', { title: escapeHtml(task.title) })}</span><span aria-hidden="true">×</span>
    </button>
    <span class="note-task-count" role="status">${t('views.taskFilter.count', { count })}</span>
    <button type="button" class="note-task-mentions" data-task-filter-mentions aria-pressed="${task.includeTitle}" title="${t('views.taskFilter.mentionsTitle')}">${t('views.taskFilter.mentions')}</button>
  </div>`;
}

export function bindTaskFilter(host, callbacks, { signal, beforeChange = () => true } = {}) {
  host.addEventListener('click', event => {
    const button = event.target.closest('[data-task-filter-clear], [data-task-filter-mentions]');
    if (!button || !host.contains(button)) return;
    event.preventDefault();
    event.stopPropagation();
    const task = getTaskFilter(callbacks);
    if (!task || !beforeChange()) return;
    const clearing = button.hasAttribute('data-task-filter-clear');
    setTaskFilter(clearing ? null : { ...task, includeTitle: !task.includeTitle }, clearing);
    host.querySelector(clearing ? 'input[type="search"]' : '[data-task-filter-mentions]')?.focus({ preventScroll: true });
  }, { signal });
}
